// extracted by mini-css-extract-plugin
export default {"settingsLink":"pUJ3wItxijATN4bFy_99","tabulateButton":"RwzMjvGCNea7LY1DXr1z"};